var inViewport = (el,classname,diff, scrollWrap) => {
	var el = document.getElementsByClassName(el);
	inFn(el,classname,diff);
	let wrap = window
	if(window.scrollHorizontal){
		wrap = scrollWrap
	}
	wrap.addEventListener('scroll', function(){
		inFn(el,classname,diff);
	})
}
var inFn = function(el,classname,diff){
	Array.prototype.forEach.call(el, e =>{
	  const rect = e.getBoundingClientRect();
	  const diffVal = diff || 1;
		const base_h = rect.height*diffVal;
	  const win_h = (window.innerHeight || document.documentElement.clientHeight);
	  const win_w = (window.innerWidth || document.documentElement.clientWidth);
	  const trans_h = diffVal<1?win_h*diffVal:0
	  const vertIn = (rect.top <= win_h-trans_h) && ((rect.top + rect.height) >= 0);
		// const	horIn = (rect.left + (rect.height*.5) <= win_w*.6) && (rect.left + rect.width >= 0);
		const	horIn = (rect.left + (rect.height*.5) <= win_w*.8) && (rect.left + rect.width >= 0);

		if(window.scrollHorizontal){
			if(horIn){
				e.classList.add(classname);
			}else{
				e.classList.remove(classname);
			}
		}else{
			if(vertIn){
				e.classList.add(classname);
			}else{
				// e.classList.remove(classname);
			}
		}
	})
} 

// call function
// inViewport(el,classname,diff)

// el : dom classname without dot
// classname :  this classname will add to el target
// diff : 設定誤差值


export default inViewport;